import React from 'react'
import Tooltip from '../../components/Tooltip'
export default () => (
  <Tooltip />
)